import { AuthContext, Logger } from '@wolfdanepug/common-react'
import { ReactNode, useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { Outlet } from 'react-router'

export const Authenticated = ({ children }: { children?: ReactNode | ReactNode[] }) => {
	const { useAuthState, useIsLoggedIn } = useContext(AuthContext)
	const state: any = useAuthState()
	const isLoggedIn = useIsLoggedIn()
	const { pathname } = useLocation()
	const navigate = useNavigate()

	useEffect(() => {
		Logger.log('Authenticated', pathname, isLoggedIn, state?.loading)
		if (pathname === '/login') {
			return
		}
		if (!isLoggedIn && !state?.loading) {
			navigate('/login')
		}
	}, [pathname, isLoggedIn, state?.loading, navigate])

	if (!isLoggedIn) {
		return null
	}

	return (
		<>
			<Outlet />
		</>
	)
}
